const NoBr: React.FC<{children?: React.ReactNode}> = ({ children }) => {
  return <span style={{
    whiteSpace: 'nowrap',
  }}>
    {children}
  </span>
}

export default NoBr